import React, { useEffect } from "react";
import Select from "react-select";
import { useForm } from "react-hook-form";
import axios from "axios";
import toastr from "../../../../utils/toast";
import { useOutletContext } from "react-router-dom";

function Leave({ onClose, data }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const status_options = [
    { value: "", label: "Select Option" },
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
  ];

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();

  const onSubmit = async (formdata) => {
    setGlobalLoading(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/approvalleaves/approve_leave`,
        formdata,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log(response);
      if (response.status === 200) {
        toastr.success(response.data.message);
        onClose(1);
      }
    } catch (error) {
      setGlobalLoading(false);
      console.log(error);
      toastr.error(error);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    setValue("employeeinfo_has_leave_id", data?.leave_id);
    setValue("employeeinfo_id", data?.user_id);
    status_options.forEach((option) => {
      if (option.value === data?.leave_status) {
        setValue("status", option);
      }
    });
    setValue("comments", data?.comments);
    setValue("user_name", data?.user_name);
    setValue("from", data?.from_date);
    setValue("to", data?.to_date);
    setValue("no_of_days", data?.no_of_days);
    console.log(data);
  }, [data]);

  return (
    <>
      <div className="modal fade show d-block" id="leave" tabIndex="-1">
        <div
          className="modal-dialog modal-dialog-centered modal-md"
          role="document"
        >
          <div className="modal-content">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="modal-header">
                <h5 className="modal-title">Leave</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    onClose?.();
                  }}
                >
                  <i className="ti ti-x"></i>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="md-3">
                      <code>
                        {data?.user_name} requested for {data?.no_of_days}{" "}
                        {Number(data?.no_of_days) > 1 ? "days" : "day"} of leave
                        From {data?.from_date} to {data?.to_date}
                        {data?.reason && (
                          <>
                            <br />
                            Reason : <b>{data?.reason}</b>
                          </>
                        )}
                      </code>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Status
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        className={`react-select react-select-default ${errors.status ? "is-invalid" : "-"}`}
                        options={status_options}
                        defaultValue={status_options[0]}
                        {...register("status", {
                          required: true,
                        })}
                        onChange={(selectedOption) => {
                          setValue("status", selectedOption);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Comment</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="comments"
                        {...register("comments")}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="modal-footer"
                style={{ justifyContent: "center" }}
              >
                <button type="submit" className="btn btn-primary me-2">
                  Save
                </button>

                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    onClose?.();
                  }}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Leave;
